module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.02669c88.woff";